import styled from 'styled-components';

import {mixins} from '@edna/components/styles';
import KeyboardArrowRightIcon from '@edna/icons/keyboardArrowRight.svg';

export const More = styled.div`
  ${mixins.stack({direction: 'ROW', size: '05', align: 'center'})};
  cursor: pointer;
  margin-top: ${({theme}) => theme.spacing.s1};
  color: ${({theme}) => theme.palette.grey600};
`;

export const MoreLabel = styled.div`
  ${mixins.f3};
  text-decoration: underline;
  text-decoration-style: dotted;
`;

export const MoreIcon = styled(KeyboardArrowRightIcon)<{isOpen: boolean}>`
  ${mixins.wh('16px')}
  transform: rotate(${({isOpen}) => (isOpen ? '90deg' : '0deg')});
  transition: transform ${({theme}) => theme.animation.duration}ms;
`;

export const Container = styled.div`
  width: 100%;
`;
